import Dropdown, { CardDropdown } from 'components/Dropdown'
import { useToast } from 'containers/ToastManager'
import copy from 'copy-to-clipboard'
import React, { FC } from 'react'

export interface PrototypeCardDropdownProps {
  pathname: string
}

const PrototypeCardDropdown: FC<PrototypeCardDropdownProps> = ({
  pathname,
}) => {
  const { showToast } = useToast()

  const copyLink = (
    withHotspots: boolean,
    event: React.SyntheticEvent<Element, Event>
  ) => {
    event.preventDefault()

    const link = `${window.location.origin}${pathname}${
      withHotspots ? '' : '?hotspots=false'
    }`
    copy(link)
    showToast('Link to Prototype copied', 'positive')
  }
  return (
    <CardDropdown>
      <>
        <Dropdown.Item onClick={event => copyLink(true, event)}>
          Copy link to Prototype with Hotspots
        </Dropdown.Item>
        <Dropdown.Item onClick={event => copyLink(false, event)}>
          Copy link to Prototype with Hotspots disabled
        </Dropdown.Item>
      </>
    </CardDropdown>
  )
}

export default PrototypeCardDropdown
